import { UserGatewayMessage } from '../../../types/UserGatewayMessage';
import { AsyncComboBox, AsyncComboBoxProps } from '../../cdl/ComboBox/ComboBox';
import { getManagementUserById, getManagementUsersList } from '../../common/api/clients/gateway.api';
import { queries } from '../../common/api/queryKeys/queries';

interface IntegrationUserSelectOption {
    label: string;
    value: string;
    user: UserGatewayMessage;
}

interface IntegrationUserSelectProps
    extends Omit<
        AsyncComboBoxProps<IntegrationUserSelectOption>,
        'onChange' | 'value' | 'optionsQueryKey' | 'optionsQueryFn' | 'selectedOptionQueryKey' | 'selectedOptionQueryFn'
    > {
    value: string;
    onChange: (option: IntegrationUserSelectOption) => void;
}

export function IntegrationUserSelect({ value, onChange, label }: IntegrationUserSelectProps) {
    const formatUser = (user: UserGatewayMessage): string => {
        if (!user.firstname || !user.lastname) {
            return user.email;
        }
        return `${user.firstname} ${user.lastname} (${user.email})`;
    };

    const loadUsersBySearchQuery = async (searchQuery: string) => {
        const response = await getManagementUsersList({
            searchQuery,
        });

        return response.content.map((user) => ({
            value: user.id,
            label: formatUser(user),
            user,
        }));
    };

    const loadUserById = async (userId: string): Promise<IntegrationUserSelectOption> => {
        const user = await getManagementUserById(userId);
        return {
            value: user.id,
            label: formatUser(user),
            user,
        };
    };

    return (
        <AsyncComboBox<IntegrationUserSelectOption>
            label={label}
            onChange={(_value, meta) => {
                if (meta.option) {
                    onChange(meta.option);
                }
            }}
            value={value || null}
            optionsQueryKey={(search) => queries.members.comboBoxOptions({ searchQuery: search }).queryKey}
            optionsQueryFn={loadUsersBySearchQuery}
            selectedOptionQueryKey={(selectedValue) => queries.members.selectedComboBoxOption(selectedValue).queryKey}
            selectedOptionQueryFn={loadUserById}
        />
    );
}
